type Props = {}

function Privacy({}: Props) {
  return (
    <div>Privacy</div>
  )
}

export default Privacy;